module.exports = __webpack_public_path__ + "static/media/shopping.bb601b1a.jpg";